import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import { auth } from '../../firebase';
import KobooButton from '../Layout/KobooButton';
import styles from '../../constants/stylesDefault';
import KobooRoundInput from '../../constants/KobooRoundInput.css';

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  email: '',
  error: null,
};

class PasswordForgetForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

    onSubmit = (event) => {
      const { email } = this.state;

      auth.doPasswordReset(email)
        .then(() => {
          this.setState(() => ({ ...INITIAL_STATE }));
        })
        .catch((error) => {
          this.setState(byPropKey('error', error));
        });

      event.preventDefault();
    };

    render() {
      const {
        email,
      } = this.state;

      const isInvalid = email === '';

      return (
            <form onSubmit={this.onSubmit} style={styles.center}>

                <TextField
                    style={KobooRoundInput.round}
                    placeholder="Email"
                    id="changepassword-email"
                    type="text"
                    onChange={event => this.setState(byPropKey('email', event.target.value))}
                    margin="normal"
                    value={email}
                    InputProps={{
                        disableUnderline: true,
                    }}
                />

                <KobooButton disabled={isInvalid} type="submit">
                    Envoyer
                </KobooButton>
            </form>
      );
    }
}


export default PasswordForgetForm;



// WEBPACK FOOTER //
// ./src/components/PasswordForgetForm/PasswordForgetForm.jsx